export default {"src":"/komodo/_next/static/media/instagram.da6805e4.svg","height":75,"width":79,"blurWidth":0,"blurHeight":0};